<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Basic Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form
                  @submit.prevent="submitForm(currentStatus)"
                  ref="addLcImportLcMaster"
                  id="addLcImportLcMaster"
                >
                  <v-row class="pa-2">
                    <v-col cols="12">
                      <v-text-field
                        label="LC No"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="lc_no.value.value"
                        :error-messages="lc_no.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          LC No
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="LC Open Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="lc_open_date.value.value"
                        :error-messages="lc_open_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>

                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Expiry Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="expiry_date.value.value"
                        :error-messages="expiry_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="supplier_id.value.value"
                        :items="getSupplierList"
                        :item-title="(item) => `${item.supplier_name}`"
                        item-value="id"
                        :error-messages="supplier_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Supplier
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                        <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="currency_id.value.value"
                        :items="getCurrencyList"
                        :item-title="(item) => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="currency_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Currency
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="incoterm_id.value.value"
                        :items="getLcIncotermList"
                        :item-title="(item) => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="incoterm_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Incoterm
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="payment_term_id.value.value"
                        :items="getLcPaymentTermList"
                        :item-title="(item) => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="payment_term_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Payment Term
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="loading_port_id.value.value"
                        :items="getLcPortList"
                        :item-title="(item) => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="loading_port_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Loading Port
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="discharge_port_id.value.value"
                        :items="getLcPortList"
                        :item-title="(item) => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="discharge_port_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Discharge Port
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="shipping_method_id.value.value"
                        :items="getLcShippingMethodList"
                        :item-title="(item) => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="shipping_method_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Shipping Method
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="advising_bank_id.value.value"
                        :items="getLcBankList"
                        :item-title="(item) => `${item.name} - ${item.branch}`"
                        item-value="id"
                        :error-messages="advising_bank_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Advising Bank
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="issuing_bank_id.value.value"
                        :items="getLcBankList"
                        :item-title="(item) => `${item.name} - ${item.branch}`"
                        item-value="id"
                        :error-messages="issuing_bank_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Issuing Bank
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="lc_type_id.value.value"
                        :items="getLcTypeList"
                        :item-title="(item) => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="lc_type_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          LC Type
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>


                      <v-textarea
                        label="Remarks"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="remarks.value.value"
                        autocomplete="off"
                        rows="3"
                        clearable
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >PI Selection & Charges</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form
                  @submit.prevent="submitForm(currentStatus)"
                  ref="addLcImportLcMaster"
                  id="addLcImportLcMaster"
                >
                  <!-- PI Selection -->
                  <v-row class="pt-2">
                    <v-col cols="12">
                      <v-autocomplete
                        label="Select Proforma Invoices (PI)"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="pi_ids.value.value"
                        :items="getLcImportPiList"
                        :item-title="(item) => `${item.pi_no} - ${item.code} (${formatDateView(item.pi_date)}) - ${$numberFormat(item.total_amount)})`"
                        item-value="id"
                        :error-messages="pi_ids.errorMessage.value"
                        autocomplete="off"
                        multiple
                        chips
                        clearable
                      >
                        <template #label>
                          Proforma Invoices (PI)
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <!-- Display Individual PI Details -->
                      <div v-if="loadingPiDetails" class="mt-4">
                        <v-progress-linear indeterminate color="primary" class="mb-2"></v-progress-linear>
                        <div class="text-caption text-center text-grey">Loading PI details...</div>
                      </div>
                      <div v-else-if="selectedPisDetails.length > 0" class="mt-4">
                        <div class="text-h6 mb-3">Proforma Invoice Details</div>
                        <div v-for="(piDetail, index) in selectedPisDetails" :key="piDetail.id || index" class="mb-4">
                          <v-card variant="outlined" class="pi-detail-card">
                            <v-card-text class="pa-0">
                              <v-expansion-panels v-model="piDetailsPanels" multiple>
                                <v-expansion-panel :value="piDetail.id">
                                  <v-expansion-panel-title class="pi-detail-header">
                                    <div class="d-flex justify-space-between align-center w-100 pr-4">
                                      <div class="d-flex align-center">
                                        <v-icon icon="mdi-file-document-outline" class="mr-2"></v-icon>
                                        <span>PI No: <strong>{{ piDetail.pi_no || piDetail.code }}</strong></span>
                                        <span class="ml-2 text-caption text-grey">
                                          ({{ formatDateView(piDetail.pi_date) }})
                                        </span>
                                      </div>
                                      <div class="text-right">
                                        <strong>{{ $numberFormat(piDetail.total_amount) }}</strong>
                                        <span class="text-caption text-grey ml-1">
                                          {{ piDetail.currency?.code || '' }}
                                        </span>
                                      </div>
                                    </div>
                                  </v-expansion-panel-title>
                                  <v-expansion-panel-text>
                                    <div class="pa-4">
                                      <!-- PI Basic Information -->
                                      <v-row class="mb-3">
                                        <v-col cols="12" md="6">
                                          <div class="text-subtitle-2 mb-2">Supplier Information</div>
                                          <div class="text-body-2">
                                            <strong>Supplier:</strong> {{ piDetail.supplier?.supplier_name || 'N/A' }}<br>
                                            <strong>Address:</strong> {{ piDetail.supplier?.supplier_address || piDetail.supplier?.address || 'N/A' }}<br>
                                            <strong>Validity:</strong> {{ piDetail.validity ? formatDateView(piDetail.validity) : 'N/A' }}<br>
                                          </div>
                                        </v-col>
                                        
                                      </v-row>

                                      <v-row class="mb-3">
                                        
                                        <v-col cols="12" md="6" v-if="piDetail.remarks">
                                          <div class="text-subtitle-2 mb-2">Remarks</div>
                                          <div class="text-body-2">{{ piDetail.remarks }}</div>
                                        </v-col>
                                      </v-row>

                                      <!-- PI Items Table -->
                                      <div class="text-subtitle-2 mb-2">PI Items</div>
                                      <v-table density="compact" class="elevation-1">
                                        <thead>
                                          <tr>
                                            <th>Code</th>
                                            <th>Product</th>
                                            <th>UOM</th>
                                            <th>HS Code</th>
                                            <th class="text-right">Quantity</th>
                                            <th class="text-right">Rate</th>
                                            <th class="text-right">Amount</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr v-for="(item, itemIndex) in (piDetail.details || [])" :key="itemIndex">
                                            <td>{{ item.product?.code || item.product_code || 'N/A' }}</td>
                                            <td>{{ item.product?.name || item.product_name || 'N/A' }}</td>
                                            <td>{{ item.product?.unit?.name || 'N/A' }}</td>
                                            <td class="text-left">{{ item.hs_code }}</td>
                                            <td class="text-right">{{ formatNumber(item.qty) }}</td>
                                            <td class="text-right">{{ formatNumber(item.rate) }}</td>
                                            <td class="text-right">{{ formatNumber(item.amount || (item.qty * item.rate)) }}</td>
                                          </tr>
                                          <tr v-if="!piDetail.details || piDetail.details.length === 0">
                                            <td colspan="5" class="text-center text-grey">No items found</td>
                                          </tr>
                                        </tbody>
                                        <tfoot>
                                          <tr>
                                            <td colspan="5" class="text-right font-weight-bold">Total Amount:</td>
                                            <td class="text-right font-weight-bold">
                                              {{ formatNumber(piDetail.total_amount || 0) }}
                                            </td>
                                          </tr>
                                        </tfoot>
                                      </v-table>
                                    </div>
                                  </v-expansion-panel-text>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </v-card-text>
                          </v-card>
                        </div>
                      </div>

                      <!-- Display Selected PIs Summary -->
                      <v-card v-if="selectedPisSummary.length > 0" class="mt-4" variant="outlined">
                        <v-card-text>
                          <div class="text-h6 mb-2">Selected PIs Summary</div>
                          <v-table density="compact">
                            <thead>
                              <tr>
                                <th>PI No</th>
                                <th>PI Date</th>
                                <th class="text-right">Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="pi in selectedPisSummary" :key="pi.id">
                                <td>{{ pi.pi_no }}</td>
                                <td>{{ formatDateView(pi.pi_date) }}</td>
                                <td class="text-right">{{ $numberFormat(pi.total_amount) }}</td>
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colspan="2" class="text-right font-weight-bold">Total LC Amount:</td>
                                <td class="text-right font-weight-bold">{{ $numberFormat(totalPiAmount) }}</td>
                              </tr>
                            </tfoot>
                          </v-table>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>

                  <!-- Charges Section -->
                  <v-row class="pt-4">
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Bank Charge"
                        density="compact"
                        type="number"
                        step="0.01"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="bank_charge.value.value"
                        :error-messages="bank_charge.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="SWIFT Charge"
                        density="compact"
                        type="number"
                        step="0.01"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="swift_charge.value.value"
                        :error-messages="swift_charge.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Insurance"
                        density="compact"
                        type="number"
                        step="0.01"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="insurance.value.value"
                        :error-messages="insurance.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <v-divider class="my-4"></v-divider>
                  <v-row class="pt-0">
                    <v-col cols="12">
                      <div class="d-flex justify-end" style="gap: 12px;">
                        <v-btn
                          class="bg-grey-darken-1"
                          variant="flat"
                          type="button"
                          :loading="loading && currentStatus === 0"
                          :disabled="loading && currentStatus !== 0"
                          @click="submitForm(0)"
                        >
                          DRAFT
                        </v-btn>
                        <v-btn
                          class="bg-primary"
                          variant="flat"
                          type="button"
                          :loading="loading && currentStatus === 1"
                          :disabled="loading && currentStatus !== 1"
                          @click="submitForm(1)"
                        >
                          POST
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import formattedDate from "@/plugins/dateFormatter";
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import { useField, useForm } from "vee-validate";
import { getCurrentInstance, ref, computed, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";
import * as yup from "yup";

export default {
  components: {},
  data: () => ({
    panel: [0],
    panel2: [0],
    loading: false,
  }),

  methods: {
    formatDateView,
  },
  
  setup() {
    const { proxy } = getCurrentInstance();
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        lc_no: yup.string().required().label("LC No"),
        lc_open_date: yup.date().required().label("LC Open Date"),
        expiry_date: yup.date().required().label("Expiry Date"),
        supplier_id: yup.number().positive().integer().required().label("Supplier"),
        currency_id: yup.number().positive().integer().required().label("Currency"),
        incoterm_id: yup.number().positive().integer().required().label("Incoterm"),
        payment_term_id: yup.number().positive().integer().required().label("Payment Term"),
        loading_port_id: yup.number().positive().integer().required().label("Loading Port"),
        discharge_port_id: yup.number().positive().integer().required().label("Discharge Port"),
        shipping_method_id: yup.number().positive().integer().required().label("Shipping Method"),
        issuing_bank_id: yup.number().positive().integer().required().label("Issuing Bank"),
        advising_bank_id: yup.number().positive().integer().required().label("Advising Bank"),
        
        lc_type_id: yup.number().positive().integer().required().label("LC Type"),
        pi_ids: yup.array().min(1, "At least one PI is required").required().label("Proforma Invoices"),
        bank_charge: yup.number().min(0).required().label("Bank Charge"),
        swift_charge: yup.number().min(0).required().label("SWIFT Charge"),
        insurance: yup.number().min(0).required().label("Insurance"),
      }),
    });

    const lc_master_id = useField("lc_master_id");
    const lc_no = useField("lc_no");
    const lc_open_date = useField("lc_open_date");
    const expiry_date = useField("expiry_date");
    const supplier_id = useField("supplier_id");
    const currency_id = useField("currency_id");
    const incoterm_id = useField("incoterm_id");
    const payment_term_id = useField("payment_term_id");
    const loading_port_id = useField("loading_port_id");
    const discharge_port_id = useField("discharge_port_id");
    const shipping_method_id = useField("shipping_method_id");
    const issuing_bank_id = useField("issuing_bank_id");
    const advising_bank_id = useField("advising_bank_id");
    const lc_type_id = useField("lc_type_id");
    const pi_ids = useField("pi_ids");
    const bank_charge = useField("bank_charge");
    const swift_charge = useField("swift_charge");
    const insurance = useField("insurance");
    const remarks = useField("remarks");
    const status = useField("status");

    const errorMessages = ref("");
    const loading = ref(false);
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const currentStatus = ref(0);
    const selectedPisDetails = ref([]);
    const piDetailsPanels = ref([]);
    const loadingPiDetails = ref(false);

    const branchId = computed(() => {
      return store.getters.getAuthUser?.branch_id || null;
    });

    const getSupplierList = computed(() => {
      return store.getters.getSupplierList || [];
    });

    const getCurrencyList = computed(() => {
      return store.getters.getCurrencyList || [];
    });

    const getLcIncotermList = computed(() => {
      return store.getters.getLcIncotermList || [];
    });

    const getLcPaymentTermList = computed(() => {
      return store.getters.getLcPaymentTermList || [];
    });

    const getLcPortList = computed(() => {
      return store.getters.getLcPortList || [];
    });

    const getLcShippingMethodList = computed(() => {
      return store.getters.getLcShippingMethodList || [];
    });

    const getLcBankList = computed(() => {
      return store.getters.getLcBankList || [];
    });

    const getLcTypeList = computed(() => {
      return store.getters.getLcTypeList || [];
    });

    const getLcImportPiList = computed(() => {
      let pis = store.getters.getLcImportPiList || [];
      return pis.filter((item) => item.branch_id == branchId.value && item.status == 1);
    });

    const selectedPisSummary = computed(() => {
      if (!pi_ids.value.value || pi_ids.value.value.length === 0) {
        return [];
      }
      return getLcImportPiList.value.filter((pi) =>
        pi_ids.value.value.includes(pi.id)
      );
    });

    const totalPiAmount = computed(() => {
      return selectedPisSummary.value.reduce((sum, pi) => sum + (parseFloat(pi.total_amount) || 0), 0);
    });

    const formatNumber = (num) => {
      if (!num && num !== 0) return "0.00";
      return Number(num).toFixed(2);
    };

    const loadPiDetails = async (piIds) => {
      if (!piIds || piIds.length === 0) {
        selectedPisDetails.value = [];
        piDetailsPanels.value = [];
        return;
      }

      loadingPiDetails.value = true;
      try {
        const detailsPromises = piIds.map(async (piId) => {
          try {
            const piData = await store.dispatch("getLcImportPiById", piId);

            if (supplier_id.value.value == null) supplier_id.value.value = piData.supplier_id;
            if (currency_id.value.value == null) currency_id.value.value = piData.currency_id;
            if (incoterm_id.value.value == null) incoterm_id.value.value = piData.incoterm_id;
            if (payment_term_id.value.value == null) payment_term_id.value.value = piData.payment_term_id;
            if (loading_port_id.value.value == null) loading_port_id.value.value = piData.loading_port_id;
            if (discharge_port_id.value.value == null) discharge_port_id.value.value = piData.discharge_port_id;
            if (shipping_method_id.value.value == null) shipping_method_id.value.value = piData.shipping_method_id;
            if (advising_bank_id.value.value == null) advising_bank_id.value.value = piData.bank_id;

            return piData;
          } catch (error) {
            console.error(`Failed to load PI ${piId}:`, error);
            return null;
          }
        });

        const details = await Promise.all(detailsPromises);
        selectedPisDetails.value = details.filter((detail) => detail !== null);
        // Auto-expand all panels
        piDetailsPanels.value = selectedPisDetails.value.map((pi) => pi.id);
      } catch (error) {
        console.error("Error loading PI details:", error);
        toast.error("Failed to load some PI details");
      } finally {
        loadingPiDetails.value = false;
      }
    };

    const loadLcMasterData = async (id) => {
      if (!id) {
        // Clear form for new entry
        lc_master_id.value.value = null;
        lc_no.value.value = "";
        lc_open_date.value.value = null;
        expiry_date.value.value = null;
        supplier_id.value.value = null;
        currency_id.value.value = null;
        incoterm_id.value.value = null;
        payment_term_id.value.value = null;
        loading_port_id.value.value = null;
        discharge_port_id.value.value = null;
        shipping_method_id.value.value = null;
        advising_bank_id.value.value = null;
        issuing_bank_id.value.value = null;
        lc_type_id.value.value = null;
        pi_ids.value.value = [];
        bank_charge.value.value = 0;
        swift_charge.value.value = 0;
        insurance.value.value = 0;
        remarks.value.value = "";
        return;
      }

      loading.value = true;
      try {
        const data = await store.dispatch("getLcImportLcMasterById", id);
        lc_master_id.value.value = data.id;
        lc_no.value.value = data.lc_no;
        lc_open_date.value.value = data.lc_open_date;
        expiry_date.value.value = data.expiry_date;
        supplier_id.value.value = data.supplier_id;
        currency_id.value.value = data.currency_id;
        incoterm_id.value.value = data.incoterm_id;
        payment_term_id.value.value = data.payment_term_id;
        loading_port_id.value.value = data.loading_port_id;
        discharge_port_id.value.value = data.discharge_port_id;
        shipping_method_id.value.value = data.shipping_method_id;
        issuing_bank_id.value.value = data.issuing_bank_id;
        advising_bank_id.value.value = data.advising_bank_id;
        lc_type_id.value.value = data.lc_type_id;
        pi_ids.value.value = (data.pis || []).map((pi) => pi.id);
        // Load PI details if PIs are selected
        if (pi_ids.value.value && pi_ids.value.value.length > 0) {
          await loadPiDetails(pi_ids.value.value);
        }
        bank_charge.value.value = data.bank_charge || 0;
        swift_charge.value.value = data.swift_charge || 0;
        insurance.value.value = data.insurance || 0;
        remarks.value.value = data.remarks || "";
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to load LC Master data");
      } finally {
        loading.value = false;
      }
    };

    onMounted(async () => {
      // Load initial data
      if (store.getters.getSupplierList.length === 0) {
        await store.dispatch("getSupplierList", {});
      }
      if (store.getters.getCurrencyList.length === 0) {
        await store.dispatch("getCurrencyList");
      }
      if (store.getters.getLcIncotermList.length === 0) {
        await store.dispatch("getLcIncotermList");
      }
      if (store.getters.getLcPaymentTermList.length === 0) {
        await store.dispatch("getLcPaymentTermList");
      }
      if (store.getters.getLcPortList.length === 0) {
        await store.dispatch("getLcPortList");
      }
      if (store.getters.getLcShippingMethodList.length === 0) {
        await store.dispatch("getLcShippingMethodList");
      }

      if (store.getters.getLcBankList.length === 0) {
        await store.dispatch("getLcBankList");
      }
      if (store.getters.getLcTypeList.length === 0) {
        await store.dispatch("getLcTypeList");
      }
      // if (store.getters.getLcImportPiList.length === 0) {
        await store.dispatch("getLcImportPiList", {type:'pi_for_lc_import'});
      // }

      // Set default values
      bank_charge.value.value = 0;
      swift_charge.value.value = 0;
      insurance.value.value = 0;

      // Load for edit
      if (route.params.id) {
        await loadLcMasterData(route.params.id);
      }
    });

    // Watch for route changes
    watch(
      () => route.params.id,
      (newId) => {
        loadLcMasterData(newId);
      },
      { immediate: false }
    );

    // Watch for PI selection changes and load details
    watch(
      () => pi_ids.value.value,
      (newPiIds, oldPiIds) => {
        if (newPiIds && newPiIds.length > 0) {
          loadPiDetails(newPiIds);
        } else {
          selectedPisDetails.value = [];
          piDetailsPanels.value = [];
        }
      },
      { immediate: false }
    );

    const submitForm = (btnStatus) => {
      currentStatus.value = btnStatus;
      status.value.value = btnStatus;

      if (!pi_ids.value.value || pi_ids.value.value.length === 0) {
        toast.error("Please select at least one Proforma Invoice");
        return;
      }

      submit();
    };

    const submit = handleSubmit(async (values) => {
      loading.value = true;
      try {
        const data = {
          lc_master_id: lc_master_id.value.value || null,
          lc_no: lc_no.value.value,
          lc_open_date: formattedDate(lc_open_date.value.value),
          expiry_date: formattedDate(expiry_date.value.value),
          supplier_id: supplier_id.value.value,
          currency_id: currency_id.value.value,
          incoterm_id: incoterm_id.value.value,
          payment_term_id: payment_term_id.value.value,
          loading_port_id: loading_port_id.value.value,
          discharge_port_id: discharge_port_id.value.value,
          shipping_method_id: shipping_method_id.value.value,
          issuing_bank_id: issuing_bank_id.value.value,
          advising_bank_id: advising_bank_id.value.value,
          lc_type_id: lc_type_id.value.value,
          pi_ids: pi_ids.value.value,
          bank_charge: parseFloat(bank_charge.value.value) || 0,
          swift_charge: parseFloat(swift_charge.value.value) || 0,
          insurance: parseFloat(insurance.value.value) || 0,
          remarks: remarks.value.value || null,
          status: status.value.value,
        };

        await store.dispatch("saveUpdateLcImportLcMaster", data);
        toast.success("LC Master saved successfully");
        router.push({ path: "/lc/import-lc-record" });
      } catch (error) {
        if (error.response?.data?.errors) {
          const errors = error.response.data.errors;
          const messages = Object.values(errors).flat().join("\n");
          toast.error(messages);
        } else {
          toast.error(error.response?.data?.message || "Failed to save LC Master");
        }
      } finally {
        loading.value = false;
      }
    });

    return {
      lc_master_id,
      lc_no,
      lc_open_date,
      expiry_date,
      supplier_id,
      currency_id,
      incoterm_id,
      payment_term_id,
      loading_port_id,
      discharge_port_id,
      shipping_method_id,
      issuing_bank_id,
      advising_bank_id,
      lc_type_id,
      pi_ids,
      bank_charge,
      swift_charge,
      insurance,
      remarks,
      status,
      getSupplierList,
      getCurrencyList,
      getLcIncotermList,
      getLcPaymentTermList,
      getLcPortList,
      getLcShippingMethodList,
      getLcBankList,
      getLcTypeList,
      getLcImportPiList,
      selectedPisSummary,
      totalPiAmount,
      formatNumber,
      selectedPisDetails,
      piDetailsPanels,
      loadingPiDetails,
      submitForm,
      loading,
      currentStatus,
    };
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}

/* PI Details Card Styling */
.pi-detail-card {
  border: 2px solid #000000 !important;
  border-radius: 8px;
}

.pi-detail-header {
  background-color: #f5f5f5;
  padding: 12px 16px;
}
</style>

